export const categoriesData: Record<string, {
  title: string;
  subtitle: string;
  description: string;
  heroImage: string;
  items: Array<{
    id: number;
    image: string;
    name: string;
    category: string;
    description: string;
    tag: string;
    link?: string;
  }>;
}> = {
  products: {
    title: '产品中心',
    subtitle: 'PRODUCTS',
    description: '探索NOPAY钱包全系列产品与服务，满足您的多样化需求',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20financial%20technology%20products%20display%2C%20dark%20elegant%20background%20with%20gold%20accents%2C%20premium%20product%20photography%20style%2C%20warm%20cinematic%20lighting%2C%20minimalist%20composition&width=1800&height=700&seq=nopay-cat-products-hero&orientation=landscape',
    items: [
      {
        id: 1,
        image: 'https://readdy.ai/api/search-image?query=Premium%20digital%20wallet%20card%20design%20on%20dark%20surface%2C%20gold%20metallic%20accents%2C%20luxury%20banking%20card%20aesthetic%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20product%20photography&width=600&height=600&seq=nopay-prod-01&orientation=squarish',
        name: 'NOPAY经典钱包',
        category: '基础产品',
        description: '安全便捷的数字资产管理工具，适合日常使用',
        tag: '热门',
        link: '/article/nopay-classic',
      },
      {
        id: 2,
        image: 'https://readdy.ai/api/search-image?query=Premium%20black%20credit%20card%20with%20gold%20trim%2C%20luxury%20exclusive%20membership%20card%20design%2C%20dark%20elegant%20background%2C%20soft%20golden%20lighting%2C%20professional%20product%20photography&width=600&height=600&seq=nopay-prod-02&orientation=squarish',
        name: 'NOPAY尊享钱包',
        category: 'VIP产品',
        description: '专属VIP通道，更高额度，更多特权',
        tag: 'VIP',
        link: '/article/nopay-vip',
      },
      {
        id: 3,
        image: 'https://readdy.ai/api/search-image?query=FIFA%20World%20Cup%20themed%20premium%20membership%20card%2C%20gold%20trophy%20design%20elements%2C%20dark%20elegant%20background%2C%20luxury%20sports%20aesthetic%2C%20warm%20lighting&width=600&height=600&seq=nopay-prod-03&orientation=squarish',
        name: '世界杯限量钱包',
        category: '限定产品',
        description: '2026世界杯主题限量版，专属收藏价值',
        tag: '限定',
        link: '/category/worldcup',
      },
      {
        id: 4,
        image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20payment%20terminal%20with%20smartphone%2C%20business%20financial%20technology%2C%20dark%20professional%20background%2C%20gold%20accents%2C%20clean%20minimalist%20product%20photography&width=600&height=600&seq=nopay-prod-04&orientation=squarish',
        name: 'NOPAY商户版',
        category: '商业产品',
        description: '为商户提供一站式数字化收款解决方案',
        tag: '商业',
        link: '/article/nopay-business',
      },
      {
        id: 5,
        image: 'https://readdy.ai/api/search-image?query=Family%20financial%20planning%20concept%20with%20multiple%20cards%2C%20warm%20home%20atmosphere%2C%20dark%20wood%20surface%2C%20golden%20lighting%2C%20premium%20lifestyle%20photography&width=600&height=600&seq=nopay-prod-05&orientation=squarish',
        name: 'NOPAY家庭账户',
        category: '特色产品',
        description: '家庭成员共享管理，财务规划更轻松',
        tag: '家庭',
        link: '/article/nopay-family',
      },
    ],
  },
  worldcup: {
    title: '世界杯专区',
    subtitle: 'FIFA WORLD CUP 2026',
    description: '2026国际足联世界杯官方合作专区，专属礼遇，激情狂欢',
    heroImage: 'https://readdy.ai/api/search-image?query=Epic%20FIFA%20World%20Cup%20stadium%20panoramic%20view%20at%20night%2C%20dramatic%20golden%20lighting%2C%20crowd%20celebration%20atmosphere%2C%20dark%20sky%20with%20spotlights%2C%20cinematic%20sports%20photography%2C%20luxury%20premium%20feel&width=1800&height=700&seq=nopay-cat-wc-hero&orientation=landscape',
    items: [
      {
        id: 1,
        image: 'https://readdy.ai/api/search-image?query=World%20Cup%20trophy%20on%20dark%20luxurious%20background%2C%20golden%20dramatic%20lighting%2C%20premium%20sports%20photography%2C%20elegant%20display%2C%20cinematic%20atmosphere&width=600&height=600&seq=nopay-wc-01&orientation=squarish',
        name: '冠军竞猜',
        category: '竞猜活动',
        description: '参与世界杯冠军竞猜，赢取千万豪礼大奖',
        tag: '热门',
        link: '/article/worldcup-bet',
      },
      {
        id: 2,
        image: 'https://readdy.ai/api/search-image?query=Soccer%20ball%20on%20luxury%20dark%20surface%20with%20gold%20sparkles%2C%20premium%20sports%20equipment%20photography%2C%20dramatic%20lighting%2C%20elegant%20composition&width=600&height=600&seq=nopay-wc-02&orientation=squarish',
        name: '每日赛事',
        category: '赛事资讯',
        description: '实时掌握世界杯最新赛况与深度分析',
        tag: '资讯',
        link: '/article/worldcup-daily',
      },
      {
        id: 3,
        image: 'https://readdy.ai/api/search-image?query=Exclusive%20VIP%20world%20cup%20gift%20box%20on%20dark%20background%2C%20gold%20ribbon%2C%20luxury%20packaging%2C%20premium%20photography%2C%20warm%20lighting%2C%20elegant%20display&width=600&height=600&seq=nopay-wc-03&orientation=squarish',
        name: '限定礼包',
        category: '专属福利',
        description: '世界杯专属限定礼包，限量发售不容错过',
        tag: '限定',
        link: '/article/worldcup-gift',
      },
      {
        id: 4,
        image: 'https://readdy.ai/api/search-image?query=Golden%20soccer%20stadium%20model%20on%20dark%20luxury%20desk%2C%20premium%20collectible%20photography%2C%20warm%20dramatic%20lighting%2C%20elegant%20composition&width=600&height=600&seq=nopay-wc-04&orientation=squarish',
        name: '纪念周边',
        category: '收藏周边',
        description: '2026世界杯官方授权纪念品，珍藏每一刻',
        tag: '收藏',
        link: '/article/worldcup-merch',
      },
    ],
  },
  news: {
    title: '新闻资讯',
    subtitle: 'NEWS',
    description: '了解NOPAY钱包最新动态与行业前沿资讯',
    heroImage: 'https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20digital%20displays%2C%20dark%20elegant%20atmosphere%2C%20gold%20accent%20lighting%2C%20professional%20corporate%20setting%2C%20warm%20cinematic%20lighting&width=1800&height=700&seq=nopay-cat-news-hero&orientation=landscape',
    items: [
      {
        id: 1,
        image: 'https://readdy.ai/api/search-image?query=Business%20handshake%20in%20luxury%20office%2C%20dark%20elegant%20setting%2C%20gold%20warm%20lighting%2C%20partnership%20announcement%2C%20professional%20corporate%20photography&width=600&height=600&seq=nopay-news-01&orientation=squarish',
        name: 'NOPAY钱包与FIFA达成战略合作',
        category: '官方公告',
        description: '正式成为2026世界杯官方合作伙伴，开启全球化新征程',
        tag: '重磅',
        link: '/article/fifa-partnership',
      },
      {
        id: 2,
        image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%20on%20dark%20background%2C%20gold%20digital%20protection%20visualization%2C%20premium%20technology%20imagery%2C%20warm%20lighting&width=600&height=600&seq=nopay-news-02&orientation=squarish',
        name: '安全系统全面升级公告',
        category: '系统公告',
        description: '新一代金融级防护系统上线，用户体验再上新台阶',
        tag: '公告',
        link: '/article/security-upgrade',
      },
      {
        id: 3,
        image: 'https://readdy.ai/api/search-image?query=Luxury%20award%20ceremony%20scene%2C%20dark%20elegant%20venue%2C%20golden%20spotlight%2C%20trophy%20on%20stage%2C%20premium%20event%20photography&width=600&height=600&seq=nopay-news-03&orientation=squarish',
        name: 'NOPAY钱包荣获年度最佳数字平台奖',
        category: '行业荣誉',
        description: '凭借卓越的用户体验和安全技术获得行业权威认可',
        tag: '荣誉',
        link: '/article/award-2026',
      },
    ],
  },
};

export const categoryBreadcrumbs: Record<string, Array<{ label: string; path?: string }>> = {
  products: [
    { label: '首页', path: '/' },
    { label: '产品中心' },
  ],
  worldcup: [
    { label: '首页', path: '/' },
    { label: '世界杯专区' },
  ],
  news: [
    { label: '首页', path: '/' },
    { label: '新闻资讯' },
  ],
};